import { Box } from '@mui/material';
import { Font } from '@react-pdf/renderer';
import { useMemo, useState } from 'react';

import { CustomPdfViewer } from '../../components/pdf/components';
import { usePdfDowVolume } from '../dashboard/components/graphs/DowVolumes';
import { usePdfPtsCoveredGraph } from '../dashboard/components/graphs/PtArrivalsPtsCovered';
import { usePdfScenarioDetail } from '../dashboard/components/graphs/scenarioDetail';
import { usePdfUserParams } from '../dashboard/components/toolbar/graphParamsController';
import { useShifts } from '../dashboard/contexts';
import PdfDocument from './PdfDocument';

const fontFileNoraml = require('./../../assets/fonts/AvenirLTStd-Book.otf');
const fontFileSemiBold = require('./../../assets/fonts/AvenirLTStd-Roman.otf');
const fontFileBold = require('./../../assets/fonts/AvenirLTStd-Black.otf');
// import { usePdfScenarioShiftCascade } from '../dashboard/components/graphs/scenarioShiftCascade';
Font.register({
  family: 'AvenirRoman',
  fonts: [
    { src: fontFileNoraml, fontWeight: 'normal' },
    { src: fontFileSemiBold, fontWeight: 'medium' },
    { src: fontFileBold, fontWeight: 'bold' },
  ],
});
export default function PdfRenderer({
  facility,
  scenario,
  day,
  scenarioLabel,
  title,
  fileName,
  onClose,
}: {
  facility: string;
  scenario: string;
  day: string;
  scenarioLabel: string;
  title?: string;
  fileName?: string;
  onClose: () => void;
}) {
  const [loadingDoc, setLoadingDoc] = useState(false);

  const {
    state: {
      shifts: { data: shiftData },
    },
  } = useShifts();
  const shifts = useMemo(() => Object.values(shiftData), [shiftData]);

  const [prevLoading, setPrevLoading] = useState(false);
  const { renderer: userParam, isLoading: loading } = usePdfUserParams({
    facility,
    scenarioLabel,
  });
  // const { renderer: compareShiftMap } = useComapreShiftMapPdf(facility);
  const { renderer: scenarioDetail, isLoading: loading1 } =
    usePdfScenarioDetail({
      scenario,
      day: '',
      shifts,
    });

  const { renderer: dowVolume, isLoading: loading2 } = usePdfDowVolume({
    scenario,
    day: '',
  });
  const { renderer: ptsCovered, isLoading: loading3 } = usePdfPtsCoveredGraph({
    scenario,
    day,
    shifts,
  });
  // const { renderer: scenarioShiftCascade } = usePdfScenarioShiftCascade({
  //   scenario,
  //   day,
  // });

  const isApiLoading = useMemo(
    () => loading || loading1 || loading2 || loading3,
    [loading, loading1, loading2, loading3]
  );
  if (prevLoading !== isApiLoading) {
    setPrevLoading(isApiLoading);
    setLoadingDoc(isApiLoading);
  }

  const PdfDoc = useMemo(
    () => (
      <PdfDocument
        graphs={{ userParam, dowVolume, scenarioDetail, ptsCovered }}
      />
    ),
    [dowVolume, ptsCovered, scenarioDetail, userParam]
  );
  return (
    <Box sx={{ width: '100%', height: '100%', position: 'relative' }}>
      <CustomPdfViewer
        title={title}
        fileName={fileName}
        onClose={onClose}
        doc={PdfDoc}
        isLoading={loadingDoc}
      />
    </Box>
  );
}
